// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import firebase from './firebase'
import JsonExcel from 'vue-json-excel'


Vue.config.productionTip = true

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    data: { },
    components: { App },
    template: '<App/>'
})

// Global Components
Vue.component('downloadExcel', JsonExcel)